import { render, staticRenderFns } from "./code-msg-new.vue?vue&type=template&id=36e2dae0&scoped=true&"
import script from "./code-msg-new.vue?vue&type=script&lang=js&"
export * from "./code-msg-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2dae0",
  null
  
)

export default component.exports